// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dropdown-container .select-input-container {
  width: 100%;
}
#dropdown-container .select-input-container .select__control {
  width: 100%;
  height: 50px;
  padding: 0px 6px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 19.5px;
  border-radius: 4px;
  border: 1px solid var(--dee3); /* Firefox */ /* Safari and Chrome */
  appearance: none;
  outline: none;
  border-radius: 8px;
}
#dropdown-container .select-input-container .select__control :focus {
  border: unset;
  outline: none;
  box-shadow: unset;
}
#dropdown-container .select-input-container .select__control :active {
  box-shadow: unset;
}
#dropdown-container .select-input-container .select__control option {
  margin: 15px 0px;
  padding: 15px 0px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 18px;
  color: var(--0000);
}
#dropdown-container .select-input-container .select__indicator-separator {
  display: none;
}
#dropdown-container .select-input-container .css-tr4s17-option {
  background-color: var(--56ff);
}
#dropdown-container .select-input-container .select__option:hover {
  background-color: var(--56ff);
  color: var(--ffff);
}

#dark .select-input-container {
  width: 100%;
}
#dark .select-input-container .select__control {
  width: 100%;
  height: 50px;
  padding: 0px 6px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 19.5px;
  border-radius: 4px;
  border: 1px solid var(--4d6c); /* Firefox */ /* Safari and Chrome */
  appearance: none;
  outline: none;
  border-radius: 8px;
  color: var(--ffff);
  background-color: var(--4d6c);
}
#dark .select-input-container .select__control :focus {
  border: unset;
  outline: none;
  box-shadow: unset;
}
#dark .select-input-container .select__control :active {
  box-shadow: unset;
}
#dark .select-input-container .select__control option {
  margin: 15px 0px;
  padding: 15px 0px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 18px;
  background-color: var(--2b4e);
  color: var(--ffff);
}
#dark .select-input-container .css-1dimb5e-singleValue {
  color: var(--ffff);
}
#dark .select-input-container .css-1jqq78o-placeholder {
  color: var(--ffff);
}
#dark .select-input-container .css-d7l1ni-option {
  color: var(--ffff);
  background-color: var(--2b4e);
}
#dark .select-input-container .css-1n6sfyn-MenuList {
  background-color: var(--2b4e);
  color: var(--ffff);
}
#dark .select-input-container .select__indicator-separator {
  display: none;
}
#dark .select-input-container .css-tr4s17-option {
  background-color: var(--4d6c);
  color: var(--ffff);
}
#dark .select-input-container .select__option:hover {
  background-color: var(--4d6c);
  color: var(--ffff);
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/Dropdown/Dropdown.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA,EACA,YAAA,EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AACN;AAAM;EACE,aAAA;EACA,aAAA;EACA,iBAAA;AAER;AAAM;EACE,iBAAA;AAER;AAAM;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AAER;AACI;EACE,aAAA;AACN;AACI;EACE,6BAAA;AACN;AAGM;EACE,6BAAA;EACA,kBAAA;AADR;;AAQE;EACE,WAAA;AALJ;AAMI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA,EACA,YAAA,EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AAJN;AAKM;EACE,aAAA;EACA,aAAA;EACA,iBAAA;AAHR;AAKM;EACE,iBAAA;AAHR;AAKM;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;AAHR;AAMI;EACE,kBAAA;AAJN;AAMI;EACE,kBAAA;AAJN;AAMI;EACE,kBAAA;EACA,6BAAA;AAJN;AAMI;EACE,6BAAA;EACA,kBAAA;AAJN;AAMI;EACE,aAAA;AAJN;AAMI;EACE,6BAAA;EACA,kBAAA;AAJN;AAOM;EACE,6BAAA;EACA,kBAAA;AALR","sourcesContent":["#dropdown-container {\r\n  .select-input-container {\r\n    width: 100%;\r\n    .select__control {\r\n      width: 100%;\r\n      height: 50px;\r\n      padding: 0px 6px;\r\n      font-size: 14px;\r\n      font-weight: 400;\r\n      font-family: \"f-400\";\r\n      line-height: 19.5px;\r\n      border-radius: 4px;\r\n      border: 1px solid var(--dee3);\r\n      -moz-appearance: none; /* Firefox */\r\n      -webkit-appearance: none; /* Safari and Chrome */\r\n      appearance: none;\r\n      outline: none;\r\n      border-radius: 8px;\r\n      :focus {\r\n        border: unset;\r\n        outline: none;\r\n        box-shadow: unset;\r\n      }\r\n      :active {\r\n        box-shadow: unset;\r\n      }\r\n      option {\r\n        margin: 15px 0px;\r\n        padding: 15px 0px;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        line-height: 18px;\r\n        color: var(--0000);\r\n      }\r\n    }\r\n    .select__indicator-separator {\r\n      display: none;\r\n    }\r\n    .css-tr4s17-option {\r\n      background-color: var(--56ff);\r\n    }\r\n    .select__option {\r\n      // background-color: unset;\r\n      &:hover {\r\n        background-color: var(--56ff);\r\n        color: var(--ffff);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n#dark {\r\n  .select-input-container {\r\n    width: 100%;\r\n    .select__control {\r\n      width: 100%;\r\n      height: 50px;\r\n      padding: 0px 6px;\r\n      font-size: 14px;\r\n      font-weight: 400;\r\n      font-family: \"f-400\";\r\n      line-height: 19.5px;\r\n      border-radius: 4px;\r\n      border: 1px solid var(--4d6c);\r\n      -moz-appearance: none; /* Firefox */\r\n      -webkit-appearance: none; /* Safari and Chrome */\r\n      appearance: none;\r\n      outline: none;\r\n      border-radius: 8px;\r\n      color: var(--ffff);\r\n      background-color: var(--4d6c);\r\n      :focus {\r\n        border: unset;\r\n        outline: none;\r\n        box-shadow: unset;\r\n      }\r\n      :active {\r\n        box-shadow: unset;\r\n      }\r\n      option {\r\n        margin: 15px 0px;\r\n        padding: 15px 0px;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        line-height: 18px;\r\n        background-color: var(--2b4e);\r\n        color: var(--ffff);\r\n      }\r\n    }\r\n    .css-1dimb5e-singleValue {\r\n      color: var(--ffff);\r\n    }\r\n    .css-1jqq78o-placeholder {\r\n      color: var(--ffff);\r\n    }\r\n    .css-d7l1ni-option {\r\n      color: var(--ffff);\r\n      background-color: var(--2b4e);\r\n    }\r\n    .css-1n6sfyn-MenuList {\r\n      background-color: var(--2b4e);\r\n      color: var(--ffff);\r\n    }\r\n    .select__indicator-separator {\r\n      display: none;\r\n    }\r\n    .css-tr4s17-option {\r\n      background-color: var(--4d6c);\r\n      color: var(--ffff);\r\n    }\r\n    .select__option {\r\n      &:hover {\r\n        background-color: var(--4d6c);\r\n        color: var(--ffff);\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
